export const Environment = {
  current: () => {
    const location = window.location.href
    let environment = 'development'
    if (/web.shipbob/.test(location)) {
      environment = 'production'
    } else if (/webqa.shipbob/.test(location)) {
      environment = 'qa'
    }
    return environment
  }
}
